/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TerminateSessionRequest = {
  sessionId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  terminateSessionRequest: components.TerminateSessionRequest;
};

/** @internal */
export const TerminateSessionRequest$inboundSchema: z.ZodType<
  TerminateSessionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  TerminateSessionRequest: components.TerminateSessionRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "TerminateSessionRequest": "terminateSessionRequest",
  });
});
/** @internal */
export type TerminateSessionRequest$Outbound = {
  session_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  TerminateSessionRequest: components.TerminateSessionRequest$Outbound;
};

/** @internal */
export const TerminateSessionRequest$outboundSchema: z.ZodType<
  TerminateSessionRequest$Outbound,
  z.ZodTypeDef,
  TerminateSessionRequest
> = z.object({
  sessionId: z.string(),
  xOnBehalfOf: z.string().optional(),
  terminateSessionRequest: components.TerminateSessionRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    terminateSessionRequest: "TerminateSessionRequest",
  });
});

export function terminateSessionRequestToJSON(
  terminateSessionRequest: TerminateSessionRequest,
): string {
  return JSON.stringify(
    TerminateSessionRequest$outboundSchema.parse(terminateSessionRequest),
  );
}
export function terminateSessionRequestFromJSON(
  jsonString: string,
): SafeParseResult<TerminateSessionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TerminateSessionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TerminateSessionRequest' from JSON`,
  );
}
